import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FlexActivityStats, FtmReportFilterType } from 'libs/domain';
import { ReportTypes } from 'libs/domain';
import { FlexTimeReportColumns } from 'libs/shared';
import { ColumnInfo } from 'libs/shared';

import { ReportDatasourceService } from '@app/src/app/components/manager-report/services/report-datasource.service';
import { FlexTimeManagerRoutes } from '@app/src/app/modules/flex-time-manager/constants';
import { QueryParamService } from '@app/src/app/shared/services/filtering/query-param.service';

import { SystemAlertModalService } from '@shared/components/system-alert-modal';
import { SystemAlertSnackBarService } from '@shared/components/system-alert-snackbar';

import { FlexReportQueryParams, flexReportSchemaQuery } from '../constants';
import { FtmReportsService } from './ftm-reports.service';

@Injectable()
export class FtmReportsActivityDatasourceService extends ReportDatasourceService<FlexActivityStats> {
  historyInfo = {
    filter: FtmReportFilterType.ACTIVITIES,
    navigate: async (item: FlexActivityStats) => {
      const snapshot = this._queryService.getQueryParamSnapshot(this._route.snapshot, flexReportSchemaQuery.parse);
      await this._queryService.updateQueryParams(
        {
          activity_ids: [item.activityId],
          start_date: snapshot.start_date,
          end_date: snapshot.end_date,
        },
        {},
        [FlexTimeManagerRoutes.ROOT, FlexTimeManagerRoutes.REPORTS, ReportTypes.FLEX_PERIOD_REGISTERED],
      );
    },
  };

  constructor(
    _router: Router,
    private _reportService: FtmReportsService,
    _alertModal: SystemAlertModalService,
    _snackBar: SystemAlertSnackBarService,
    private _queryService: QueryParamService,
    private _route: ActivatedRoute,
  ) {
    super(_router, _reportService, FtmReportsActivityDatasourceService.name, _alertModal, _snackBar);
    // TODO: add summary link
    const linkCols: ColumnInfo[] = [
      {
        header: '',
        key: this.TEMPLATE_KEYS.HISTORY,
        columnClasses: ['w-16'],
      },
    ];
    super.setDisplayColumns(FlexTimeReportColumns.ACTIVITIES, linkCols);
  }

  async fetch(offset: number, limit: number): Promise<{ items: FlexActivityStats[]; pageToken: number }> {
    return this._reportService.getActivitiesReport(offset, limit, this._currentSort);
  }
}
